import React from 'react';
import { Button } from './globalStyles';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaLinkedin
} from 'react-icons/fa';
import {
  FooterContainer,
  FooterSubscription,
  FooterSubText,
  FooterSubHeading,
  Form,
  FormInput,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  SocialIcon,
  WebsiteRights,
  SocialIcons,
  SocialIconLink
} from './Footer.elements';

function Footer() {
  return (
    <FooterContainer>
      <FooterSubscription>
        <FooterSubHeading>
           Become a member and save on all things appliances! Services & Products
        </FooterSubHeading>
        <FooterSubText>It is FREE you can unsubscribe at any time.</FooterSubText>
        <SocialLogo to='/login'>
          <img className="logoimg" src="https://imgur.com/L0n3MhL.png" />

          </SocialLogo>
      </FooterSubscription>
     
      <SocialMedia>
        <SocialMediaWrap>
        <SocialLogo to='/login'>
          <img className="logoimg" src="https://imgur.com/tj7jAc2.jpg" />

          </SocialLogo>
          <WebsiteRights><a href="https://cities-web-design.web" target='_blank' aria-label='7cities' >7 CITIES WEB DESIGN © 2020</a></WebsiteRights>
          <SocialIcons>
            <SocialIconLink href='https://developers.facebook.com/' target='_blank' aria-label='Facebook'>
              <FaFacebook />
            </SocialIconLink>
            <SocialIconLink href='https://www.instagram.com' target='_blank' aria-label='Instagram'>
              <FaInstagram />
            </SocialIconLink>
            <SocialIconLink
              href={
                'https://www.youtube.com/'
              }
              rel='noopener noreferrer'
              target='_blank'
              aria-label='Youtube'
            >
              <FaYoutube />
            </SocialIconLink>
            <SocialIconLink href='/' target='_blank' aria-label='Twitter'>
              <FaTwitter />
            </SocialIconLink>
            <SocialIconLink href='/' target='_blank' aria-label='LinkedIn'>
              <FaLinkedin />
            </SocialIconLink>
          </SocialIcons>
        </SocialMediaWrap>
      </SocialMedia>
    </FooterContainer>
  );
}

export default Footer;
